export default "__VITE_ASSET__42125d1c__"